import { Platform } from 'react-native';
import { useState } from 'react';

/** Web-only hover state. On native this is always false and props are no-ops. */
export function useHover() {
  const [hovered, setHovered] = useState(false);
  const hoverProps =
    Platform.OS === 'web'
      ? { onHoverIn: () => setHovered(true), onHoverOut: () => setHovered(false) }
      : {};
  return { hovered, hoverProps } as const;
}
